module.exports = __webpack_public_path__ + "img/海龙.3765cfb8.jpg";